import Link from "@components/blog/Link";
import Button from "components/library/Button";

export default function FourZeroFour() {
  return (
    <div className="flex flex-col items-start justify-start md:mt-60 md:flex-row md:items-center md:justify-center md:space-x-36">
      <div className="pb-42 space-x-8 pt-36 md:space-y-20">
        <h1 className="text-6xl md:text-8xl font-bold leading-9 tracking-tight text-gray-900 dark:text-gray-100 md:px-36 ">
          404
        </h1>
      </div>
      <div className="max-w-md">
        <p className="mb-16 text-24-28 font-bold leading-normal md:text-28-32">
          Sorry we couldn&apos;t find this page.
        </p>
        <p className="mb-16">
          But don&apos;t worry, you can find plenty of other things on our
          homepage.
        </p>
        <Link href="/">
          <Button>Back to homepage</Button>
        </Link>
      </div>
    </div>
  );
}
